import React, { Component } from "react";
import {
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
  Form,
} from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import { fire, auth } from "../../firebase/index";
import "../../routes/app";
import {
  getUserDetails,
  getUserNickName,
  getSuperAdminID,
  promptSaveConfirmation,
} from "./EditProfileHelper";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import { customLog } from "../../variables/Variables";

import EmailSetting from "../SettingManagement/emailSetting";

//CSS
import "../../assets/css/maincss.css";

//IMG
import PencilIcon from "../../assets/img/pencil.png";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    nameTitle: "Member Name",
    nicknameTitle: "Nickname",
    companyNameTitle: "Company Name",
    emailAddressTitle: "Email Address",
    resetButton: "Reset",
    updateSuccess: "Profile has been updated successfully !",
    updateError: "Opps ! Something went wrong, Please try again later !",
    roleTitle: "User Role",
    superAdminName: "Super admin",
    adminName: "Admin",
    regularUserName: "Member (Non-admin)",
    usernameTip: "This member name can only be changed by the Super Admin.",
    editButton: "Edit",
    saveChangesButton: "Save Changes",
    cancelButton: "Cancel",
  },
  ja: {
    nameTitle: "名前",
    nicknameTitle: "名前-2",
    companyNameTitle: "会社名",
    emailAddressTitle: "Eメール",
    resetButton: "リセット",
    updateSuccess: "プロフィールの更新が完了しました。",
    updateError: "何らかの問題により更新できませんでした。再度入力して下さい。",
    roleTitle: "メンバー階層",
    superAdminName: "管理者",
    adminName: "管理者",
    regularUserName: "メンバー",
    usernameTip: "名称変更は管理者のみ行うことができます。",
    editButton: "変更",
    saveChangesButton: "変更内容を保存",
    cancelButton: "キャンセル",
  },
  es: {
    nameTitle: "Nombre de usuario",
    nicknameTitle: "Apodo",
    companyNameTitle: "Nombre de la empresa",
    emailAddressTitle: "Dirección de correo electrónico",
    resetButton: "Restablecer",
    updateSuccess: "¡El perfil se ha actualizado con éxito!",
    updateError:
      "¡Ups! Algo salió mal, ¡por favor intenta nuevamente más tarde!",
    roleTitle: "Rol del usuario",
    superAdminName: "Super administrador",
    adminName: "Administrador",
    regularUserName: "Miembro (No administrador)",
    usernameTip:
      "Este nombre de usuario solo puede ser cambiado por el Super Administrador.",
    editButton: "Editar",
    saveChangesButton: "Guardar cambios",
    cancelButton: "Cancelar",
  },
});

const EDIT_STATE = 1;
const DEFAULT_STATE = 0;
const db = fire.database();

class EditProfile extends Component {
  constructor(props) {
    super(props);

    this.onSave = this.onSave.bind(this);
    this.onReset = this.onReset.bind(this);

    this.state = {
      currentEmail: "",
      currentName: "",
      currentCompanyName: "",
      currentNickName: "",
      _notificationSystem: null,

      settingsState: DEFAULT_STATE, //default is 0?
      inputState: false,
      isSuperAdmin: false,

      backupName: "",
      backupCompanyName: "",
      backupNickName: "",
    };

    this.handleEditState = this.handleEditState.bind(this);
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  async componentWillMount() {
    await getSuperAdminID(auth.currentUser.email, (callbackID) => {
      //callbackID is the user id for account
      getUserNickName(callbackID, (userNickname) => {
        customLog(`checking the nickname ${userNickname}`);
        this.setState({
          currentNickName: userNickname,
          backupNickName: userNickname,
        });
      });
    });

    getUserDetails((userDetails) => {
      let companyName = userDetails.company;
      let currUserName = userDetails.name;
      let currEmail = userDetails.email;

      this.setState({
        currentName: currUserName,
        currentEmail: currEmail,
        currentCompanyName: companyName,
        backupName: currUserName,
        backupCompanyName: companyName,
      });
    });

    //checking for Super Admin
    // db
    //   .ref("groupAccounts")
    //   .child(auth.currentUser.uid )
    //   .once("value")
    //   .then(snapshot => {
    //     if(snapshot.exists()){
    //       const superAdmin= snapshot.key;
    //        console.log(`key is ${superAdmin}`)
    //     }
    //   })

    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
    customLog("checking the following>>>");

    db.ref("groupAccounts")
      .child(auth.currentUser.uid)
      .child("members")
      .once("value")
      .then((members) => {
        members.forEach((member) => {
          let memberVal = member.val();
          let memberUid = memberVal.memberUid;

          // if the member email is similar to the auth email (login email of user)
          // if the member name is not undefined or empty

          if (memberVal.memberEmail === auth.currentUser.email) {
            if (
              memberVal.memberName !== undefined ||
              memberVal.memberName !== null ||
              memberVal.memberName !== ""
            ) {
              db.ref("groupAccounts")
                .child(auth.currentUser.uid)
                .child("members")
                .child(memberUid)
                .once("value")
                .then((snapshot) => {
                  // console.log(`the nickname is ${snapshot.val().memberName}`);
                  // console.log( `checking member uid -> ${memberUid}`)
                });
            }
          }
        });
      });

    //checking if current user log in is superAdmin

    db.ref("groupAccounts/" + auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          customLog(`user is a super admin`);
          this.setState({
            isSuperAdmin: true,
          });
        } else {
          customLog(`user is not a super admin`);
          this.setState({
            isSuperAdmin: false,
          });
        }
      });

    const groupAccountsDB = fire.database().ref("groupAccounts");

    groupAccountsDB.once("value").then((snapshot) => {
      if (snapshot.exists()) {
        snapshot.forEach((eachSuperAdmin) => {
          const superAdminDetails = eachSuperAdmin.val();
          // const superAdminId = eachSuperAdmin.key;
          const members = superAdminDetails.members;

          for (const eachMembers in members) {
            const memberDetails = members[eachMembers];
            if (memberDetails.memberEmail === auth.currentUser.email) {
              const paymentDetails = superAdminDetails.payment.isPaymentValid;
              this.setState({
                isAdmin: memberDetails.isAdmin,
                isSuperAdmin: memberDetails.isSuperAdmin,
                isPaymentValid: paymentDetails,
              });
            }
          }
        });
        // this.setState({ isPaymentValid: snapshotVal.isPaymentValid });
      }
    });
  }

  onReset() {
    getUserDetails((userDetails) => {
      let companyName = userDetails.company;
      let currUserName = userDetails.name;
      let currEmail = userDetails.email;

      this.setState({
        currentName: currUserName,
        currentEmail: currEmail,
        currentCompanyName: companyName,
      });
    });
  }

  async onSave() {
    await promptSaveConfirmation(
      this.state.currentName,
      this.state.currentCompanyName,
      this.state.currentNickName,

      (response) => {
        let level,
          message = "";

        customLog(response);
        if (response) {
          level = "success";
          message = localizationStrings.updateSuccess;
          this.setState({
            settingsState: DEFAULT_STATE,
            backupName: this.state.currentName,
            backupNickName: this.state.currentNickName,
            backupCompanyName: this.state.currentCompanyName,
          });
        } else {
          level = "error";
          message = localizationStrings.updateError;
        }

        this.state._notificationSystem.addNotification({
          title: <span data-notify="icon" className="pe-7s-check"></span>,
          message: <div>{message}</div>,
          level: level,
          position: "tc",
          autoDismiss: 10,
        }); //End of notificationSystem.addNotification({})
      }
    );
  }

  handleEditState(e) {
    e.preventDefault();

    // this.setState ({
    //   settingsState: DEFAULT_STATE,
    // });

    if (this.state.settingsState === DEFAULT_STATE) {
      this.setState({
        settingsState: EDIT_STATE,
      });
    } else if (this.state.settingsState !== DEFAULT_STATE) {
      this.setState({
        settingsState: DEFAULT_STATE,
        currentName: this.state.backupName,
        currentNickName: this.state.backupNickName,
        currentCompanyName: this.state.backupCompanyName,
      });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div
        style={{
          width: "100%",
          // marginRight: "auto",
          // marginLeft: "auto",
          // display: "flex",
          // justifyContent: "center"
        }}
      >
        <NotificationSystem ref="notificationSystem" style={style} />
        <Form>
          <FormGroup style={{ width: "100%" }}>
            <div className="editprofilefirstrow">
              <div className="editprofilenicknamefield">
                <ControlLabel
                  style={{
                    whiteSpace: "nowrap",
                    width: "60%",
                    fontSize: "18px",
                  }}
                >
                  {localizationStrings.nameTitle}
                  <a data-tip data-for="usernameTip">
                    <span
                      style={{
                        color: "#3C3E41",
                        fontSize: "16px",
                        marginLeft: "10px",
                      }}
                      className="glyphicon glyphicon-info-sign"
                      aria-hidden="true"
                    ></span>
                  </a>
                  <ReactTooltip id="usernameTip" effect="solid">
                    <span>{localizationStrings.usernameTip}</span>
                  </ReactTooltip>
                </ControlLabel>
                <FormControl
                  className="editprofiletextfield"
                  type="text"
                  id="nickname"
                  name="nickname"
                  title={this.state.currentNickName}
                  value={this.state.currentNickName}
                  onChange={(event) =>
                    this.setState({ currentNickName: event.target.value })
                  }
                  disabled={
                    this.state.settingsState === DEFAULT_STATE &&
                    this.state.isSuperAdmin === true
                      ? true
                      : this.state.settingsState === DEFAULT_STATE &&
                        this.state.isSuperAdmin === false
                      ? true
                      : this.state.settingsState !== DEFAULT_STATE &&
                        this.state.isSuperAdmin === true
                      ? false
                      : this.state.settingsState !== DEFAULT_STATE &&
                        this.state.isSuperAdmin === false
                      ? true
                      : true
                  }
                />
              </div>
              <div className="editprofilecompanyfield">
                <ControlLabel
                  style={{
                    whiteSpace: "nowrap",
                    width: "60%",
                    fontSize: "18px",
                  }}
                >
                  {localizationStrings.companyNameTitle}
                </ControlLabel>
                <FormControl
                  className="editprofiletextfield"
                  type="text"
                  id="companyname"
                  name="companyname"
                  title={this.state.currentCompanyName}
                  value={this.state.currentCompanyName}
                  onChange={(event) =>
                    this.setState({
                      currentCompanyName: event.target.value,
                    })
                  }
                  disabled={
                    this.state.settingsState === DEFAULT_STATE ? true : false
                  }
                />
              </div>
              {/* <div className="editprofileusernamefield">
                <ControlLabel
                  style={{
                    whiteSpace: "nowrap",
                    width: "60%",
                    fontSize: "18px",
                  }}
                >
                  {localizationStrings.nicknameTitle}
                </ControlLabel>
                <FormControl
                  className="editprofiletextfield"
                  type="text"
                  id="username"
                  name="username"
                  title={this.state.currentName}
                  value={this.state.currentName}
                  onChange={(event) =>
                    this.setState({ currentName: event.target.value })
                  }
                  disabled={
                    this.state.settingsState === DEFAULT_STATE ? true : false
                  }
                />
              </div> */}
            </div>
            <div className="editprofilesecondrow">
              <div className="editprofileemailfield">
                <ControlLabel
                  style={{
                    whiteSpace: "nowrap",
                    width: "60%",
                    fontSize: "18px",
                  }}
                >
                  {localizationStrings.emailAddressTitle}
                </ControlLabel>
                {this.state.settingsState === DEFAULT_STATE ? null : (
                  <EmailSetting />
                )}
                <FormControl
                  className="editprofileemailtextfield"
                  type="email"
                  id="emailaddr"
                  name="emailaddr"
                  title={this.state.currentEmail}
                  value={this.state.currentEmail}
                  // onChange={event =>
                  //   this.setState({ passwordTwo: event.target.value })
                  // }
                  // onKeyUp={this.cfmPassword}
                  // disabled={ this.state.settingsState === DEFAULT_STATE ? true : false}
                  disabled={true}
                />

                {/* {
                  this.state.settingsState === DEFAULT_STATE ? 
                  <div></div> :
                  <EmailSetting />
                } */}
              </div>
              <div className="userroletextfield">
                <ControlLabel
                  style={{
                    whiteSpace: "nowrap",
                    width: "60%",
                    fontSize: "18px",
                  }}
                >
                  {localizationStrings.roleTitle}
                </ControlLabel>

                <FormControl
                  className="userroletextfield"
                  type="text"
                  id="userrole"
                  name="userrole"
                  title={
                    this.state.isSuperAdmin
                      ? localizationStrings.superAdminName
                      : this.state.isAdmin
                      ? localizationStrings.adminName
                      : localizationStrings.regularUserName
                  }
                  value={
                    this.state.isSuperAdmin
                      ? localizationStrings.superAdminName
                      : this.state.isAdmin
                      ? localizationStrings.adminName
                      : localizationStrings.regularUserName
                  }
                  disabled={true}
                />
              </div>
            </div>

            <div className="editprofilebuttons">
              {this.state.settingsState === DEFAULT_STATE ? (
                <div className="editprofilesavebtn">
                  <Button
                    style={{
                      color: "white",
                      backgroundColor: "#429ff4",
                      padding: "8px 18px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      borderRadius: "5px",
                      border: "none",
                    }}
                    onClick={this.handleEditState}
                  >
                    {localizationStrings.editButton}
                  </Button>
                </div>
              ) : (
                <div className="editprofilebuttons">
                  <div className="editprofilesavebtn">
                    <Button
                      style={{
                        color: "white",
                        backgroundColor: "#429ff4",
                        padding: "8px 18px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        borderRadius: "5px",
                        border: "none",
                      }}
                      onClick={this.onSave}
                    >
                      {localizationStrings.saveChangesButton}
                    </Button>
                  </div>

                  <div className="cancelBtn">
                    <Button
                      style={{
                        color: "white",
                        backgroundColor: "red",
                        padding: "8px 18px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        borderRadius: "5px",
                        border: "none",
                      }}
                      onClick={this.handleEditState}
                    >
                      {localizationStrings.cancelButton}
                    </Button>
                  </div>
                </div>
              )}

              {/* <div className="editprofileresetbtn">
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "#429ff4",
                    padding: "8px 18px",
                    fontSize: "18px",
                    fontWeight: "bold",
                    borderRadius: "5px",
                    border: "none"
                  }}
                  onClick={this.onReset}
                >
                  {localizationStrings.resetButton}
                </Button>
              </div> */}
            </div>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default EditProfile;
